import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop ordering. On drop, PATCHes the ordered ids to `urlValue`.
export default class extends Controller {
  static values = { url: String, handle: { type: String, default: ".drag-handle" }, param: { type: String, default: "ids" } }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: this.handleValue,
      ghostClass: "opacity-40",
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  async persist() {
    const ids = Array.from(this.element.querySelectorAll("[data-id]")).map((el) => el.dataset.id)
    const token = document.querySelector("meta[name='csrf-token']")?.content
    await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token, Accept: "text/vnd.turbo-stream.html" },
      body: JSON.stringify({ [this.paramValue]: ids })
    })
  }
}
